import styled from 'styled-components';
import { createGradientOrSolid } from 'utils/index';
import { Gradient } from 'utils/types';
import { breakpoints } from 'styles/breakpoints';

interface IStyledBingoPopProps {
  backgroundColor: Gradient;
  backgroundSrc?: string;
}

export const StyledBingoPop = styled.div<IStyledBingoPopProps>`
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  width: 100%;
  height: 166px;
  position: relative;
  border-radius: 21px;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  background-size: 100% 100%;
  padding: 17px 13px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  min-width: 235px;
  justify-content: space-between;
  
  @media (min-width: ${breakpoints.tablet}) {
    height: 249px;
    padding: 24px 13px;
  }
` as any;

export const StyledBingoPopEmblem = styled.div`
  position: absolute;
  left: -17px;
  top: -6px;
  max-height: 88px;
  max-width: 98px;
  z-index: 1000;

  img {
    max-height: 88px;
    max-width: 98px;
  }
`;

export const StyledBingoPopPriceContainer = styled.div<{}>`
  position: relative;
  width: 100%;

  .timer {
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 7px;
    font-size: 10px;
    font-weight: 400;
    color: white;
    width: 80px;
  }

  .availability {
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 7px;
    font-size: 12px;
    font-weight: 400;
    color: white;
    width: 80px;
  }

  .price {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: relative;
    border: 2px solid #2d5702;
    height: 36px;
    max-width: 154px;
    padding: 3px 4px 4px 4px;
    border-radius: 6px;
    background: var(--button-bg-color);
    box-shadow: 0px 2px 0px 0px rgb(211 249 167) inset;

    &:before {
      content: '';
      width: 4px;
      filter: blur(1px);
      height: 3px;
      background-color: white;
      border-radius: 50%;
      transform: rotate(-60deg);
      position: absolute;
      top: 3px;
      left: 1px;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      height: 21px;
      width: 100%;
      border-radius: 0 0 4px 4px;
      background: linear-gradient(270deg, #4ea301 0%, #4a9e01 100%);
      box-shadow: 0px -2px 0px 0px rgba(65 117 31) inset;
    }

    .totalPrice {
      position: relative;
      z-index: 1;
      font-size: 1.25rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      align-items: center;

      .final-price {
        font-size: 24px;
      }

      .isFree {
        font-size: 24px;
      }

      .stroked {
        color: #2e5702;
        font-size: 14px;
      }
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    .timer,
    .availability {
      font-size: 12px;
    }

    .price {
      font-size: 30px;
      height: 45px;
      max-width: 200px;
    }
  }
`;
